<template>
  <layout-main-inner title="机构信息"
                     showBack>
    <layout-card-wrap hasHeaderSlot
                      v-loading="loading">
      <template slot="title">基本信息</template>
      <el-button slot="form"
                 type="primary"
                 @click="edit"
                 :loading="loading">编辑</el-button>
      <el-form disabled
               label-position='top'>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="机构名称：">{{supervise.regulatorName}} </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构联系人：">{{supervise.regulatorPerson}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构手机号：">{{supervise.regulatorPhone}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构邮箱：">{{supervise.regulatorEmail || '-'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构地址：">{{supervise.regulatorAddress || '-'}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <supervise-staff-table v-if="showStaffSettings" />
    <supervise-edit-modal :callback="getregulator"
                          ref="modal" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import Supervise from '@/service/supervise'
import SuperviseEditModal from './busi/supervise-edit-modal.vue'
import SuperviseStaffTable from './busi/supervise-staff-table.vue'
export default {
  name: 'supervise-detail',
  components: { SuperviseEditModal, SuperviseStaffTable },
  data () {
    return {
      loading: false,
      supervise: { }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    }),
    showStaffSettings ({ userDetail, userInfo }) {
      return userDetail.staffVendorDataScope === 1 && userInfo.isAdmin === 1
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getregulator () {
      this.loading = true
      Supervise.getregulator({ regulatorId: this.$route.query.regulatorId })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if (result === 0) {
            this.supervise = res.data
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          this.$message.error(err.message)
        })
    },
    edit () {
      this.$refs.modal.fetchSupervise(this.supervise.regulatorId)
    }
  },
  mounted () {
    this.getregulator()
  }
}
</script>
